import React from 'react';

const Callout = ({ type = 'info', title, children }) => {
  const typeStyles = {
    info: {
      container: 'bg-green-500/5 border-green-500/20',
      title: 'text-green-500',
      icon: '💡',
    },
    warning: {
      container: 'bg-yellow-500/5 border-yellow-500/20',
      title: 'text-yellow-500',
      icon: '⚠️',
    },
    tip: {
      container: 'bg-blue-500/5 border-blue-500/20',
      title: 'text-blue-500',
      icon: '💡',
    },
  };

  const styles = typeStyles[type] || typeStyles.info;

  return (
    <div className={`rounded-xl border p-5 flex gap-4 ${styles.container}`}>
      <span className="text-2xl">{styles.icon}</span>
      <div>
        {title && (
          <div className={`font-semibold text-sm mb-1 ${styles.title}`}>
            {title}
          </div>
        )}
        <div className="text-zinc-400 text-sm leading-relaxed">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Callout;
